/**
 * ATTEST-UI-1 screen 7 — letter and refusal history. **Stub, gated OFF.**
 *
 * The brief makes this conditional: "only if persistence lands in Session 2 …
 * If persistence isn't in yet, stub behind a feature flag; do not fake it."
 * Persistence did not land — every attest POST is `# conformance: read-only`
 * and nothing is written — so this route renders an honest placeholder and the
 * flag stays off. See `@/components/attest/flags`.
 *
 * A refusal record is the audit artefact that matters here: the value of
 * refusing is only provable if the refusal was kept. That is the follow-on
 * brief, not a screen to invent now.
 */
import { Link } from 'react-router-dom'
import { ATTEST_HISTORY_ENABLED } from '@/components/attest/flags'
import { buttonVariants } from '@/components/ui/button'

export function LetterHistory() {
  return (
    <div className="max-w-3xl space-y-4 p-4 sm:p-6" data-testid="attest-history">
      <header>
        <h1 className="text-2xl font-semibold">Letter and refusal history</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Every issued letter and every refusal, with the guardrail that fired.
        </p>
      </header>

      <div className="rounded-lg border border-border bg-muted/40 p-4">
        <p className="text-sm text-gray-800">
          {ATTEST_HISTORY_ENABLED
            ? 'History is enabled but no persistence layer is deployed, so there is nothing to read back yet.'
            : 'Not available yet.'}{' '}
          Letter generation currently computes and returns the document without storing it —
          no letter, and no refusal, is written anywhere. Rather than show an empty list that
          looks like &ldquo;no letters issued&rdquo;, this screen stays explicit until the
          persistence work lands.
        </p>
      </div>

      <Link to="/attest/letters" className={buttonVariants({ variant: 'outline' })}>
        Generate a letter
      </Link>
    </div>
  )
}

export default LetterHistory
